// extracted by mini-css-extract-plugin
export var baseButton = "_vh-0";
export var controlsArrowKeys = "_vh-1";
export var controlsResetButton = "_vh-2";
export var lightGameButton = "_vh-4 _vh-0";
export var playAgainButton = "_vh-5 _vh-0";
export var startGameButton = "_vh-3 _vh-0";